export interface FeedbackLLMRequest {
  title?: string;
  feedbackBody?: string;
  rating?: string;
  productName?: string;
}
